import { 
    GraphQLResult 
} from "@aws-amplify/api-graphql"

import DGUtility from "../Model/DGUtility.m"

import { Rank, User } from "../API"

export type StyleModel = {
    container: object,
    light: object,
    dark: object,
}

export class Personnel extends DGUtility {
    /*** Private Members ***/
    
    // Define your view's data model using private members here...
    
    /*** Protected Members ***/
    
    /*** Private Methods ***/
    
    /*** Protected Methods ***/
    
    /**
     * Initialize and perform setup for the class
     */
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        // Perform additional setup here...
    }
    
    /*** Public Methods ***/
    
    /**
     * Class constructor. Calls _init() on the superclass. Add parameters as needed
     */
    public constructor() {
        super()
        this._init()
    }

    public sortPersonnel = (d) => {
        d = d.sort((a: User, b: User) => {
            return a.Name.localeCompare(b.Name)
        })

        d = d.sort((a: User, b: User) => {
            return -a.Rank.localeCompare(b.Rank)
        })

        return d
    }
    
    public loadPersonnel = async () => {
        const res = await this.db.executeGQL("listUsers")
        if (res && !!res?.length) {
            return res
        } else {
            console.error("Failed to load personnel data")
            return false
        }
            
    }

    public updateRank = async (user: User, rank: string) => {
        console.log("Updating rank for user:", user, "to rank:", rank)
        this._ctx.loading.setMessage(`Updating rank for ${user.Name} to ${rank}`)
        this._ctx.loading.update(true)
        
        return true
    }

    public loadRanks = async () => {
        const res = await this.db.executeGQL("listRanks")
        if (res && !!res?.length) {
            res.sort((a: Rank, b: Rank) => {
                return a.Value - b.Value
            })

            return res
        } else {
            console.error("Failed to load ranks data")
            return false
        }
    }
}

// Instantiate the VM and export the instance
const PersonnelVM = new Personnel()

export default PersonnelVM
